import { IconProps, TextProps, Box, Icon, IconSize, Text } from '@bechtel/gds';
import React, { Fragment, FC } from 'react';

interface ActionContentProps {
  icon: IconProps['icon'];
  label: string;
  labelSize?: TextProps['size'];
}

export const ActionContent: FC<ActionContentProps> = ({ icon, label, labelSize = '400' }) => {
  return (
    <Fragment>
      <Box mr={{ sm: '400' }}>
        <Icon icon={icon} size={IconSize.MEDIUM} />
      </Box>
      <Text size={labelSize} weight="600">
        {label}
      </Text>
    </Fragment>
  );
};
